export enum AvatarSize {
  XSmall = "XSmall",
  Small = "Small",
  Regular = "Regular",
  Medium = "Medium",
  Large = "Large",
}
